import { render, staticRenderFns } from "./ModalAssinaturaDigitalGenerico.vue?vue&type=template&id=562bc356&scoped=true"
import script from "./ModalAssinaturaDigitalGenerico.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaDigitalGenerico.vue?vue&type=script&lang=js"
import style0 from "./ModalAssinaturaDigitalGenerico.vue?vue&type=style&index=0&id=562bc356&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bc356",
  null
  
)

export default component.exports